<template>
  <mds-modal
    actionRequired="true"
    aria-label="Upload Modal"
    v-model:visible="toggle"
    width="100%"
  >
    <mds-button-container style="margin-bottom: 0.5%; text-align: end">
      <mds-button
        type="button"
        @click="toggle = !toggle"
        :disabled="showModelLoader"
        variation="icon-only"
        icon="remove"
        >Close</mds-button
      >
    </mds-button-container>
    <FileUpload
      v-if="toggle"
      :eventIdProp="eventIdProp"
      :uploadedDetails="uploadedDetails"
      :eventNameProp ="eventNameProp"
      @showModelLoader="handleshowModelLoader"
      @updateDetails="handleUpdateDetails"
    ></FileUpload>
  </mds-modal>
  <mds-modal
    aria-label="Loader Modal"
    actionRequired="true"
    v-model:visible="showModelLoader"
    size="small"
    style="width: 7%; height: auto; background-color: white; border: 0px"
  >
    <ModelLoader></ModelLoader>
  </mds-modal>
  <mds-alert
    v-if="showAlert"
    v-bind:variation="alertVariation"
    v-bind:title="alertTitle"
    tinted
    @mds-alert-dismissed="closeAlert"
  >
    {{ alertMessage }}
  </mds-alert>
  <mds-card
    style="width: 100%; margin-top: 1%; min-height: 80vh"
    title="Conference Call Tracker"
    caption="Select Filter and View Conference Call Details here"
  >
    <template #mds-card-action>
      <mds-form>
        <mds-fieldset id="fsFilter" horizontal>
          <mds-input
            style="min-width:120px"
            id="inComapnyId"
            label="Company Id"
            v-model="CompanyId"
          ></mds-input>
          <mds-input
            style="min-width:120px"
            id="inEventId"
            label="Event Id"
            v-model="EventId"
          ></mds-input>
          <mds-combo-box
            label="EventType"
            multiple
            v-model="selectecEventTypes"
            :data-set="[
              { text: 'Brokers/Investment bank Call', value: '5' },
              { text: 'First Quarter Earnings Conference Call', value: '12' },
              { text: 'Second Quarter Earnings Conference Call', value: '13' },
              { text: 'Third Quarter Earnings Conference Call', value: '14' },
              { text: 'Fourth Quarter Earnings Conference Call', value: '15' },
              { text: 'Sales Call', value: '16' },
              { text: 'Analyst/Investor Day or meet', value: '17' },
              { text: 'Strategic/Management update Call', value: '18' },
              { text: 'M&A/Spin-off Call', value: '19' },
              { text: 'Q1 Guidance Call', value: '20' },
              { text: 'Q2 Guidance Call', value: '21' },
              { text: 'Q3 Guidance Call', value: '22' },
              { text: 'Q4 Guidance Call', value: '23' },
              { text: 'Other Guidance Call', value: '24' },
              { text: 'Fireside chats', value: '25' },
              { text: 'Roadshow Calls', value: '26' },
              { text: 'Capital Markets Day', value: '27' },
              { text: 'Other Conference call', value: '28' },
              { text: 'Annual General Meeting', value: '29' },    
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Priority"
            multiple
            v-model="Priority"
            :data-set="[
              { text: '1', value: '1' },
              { text: '2', value: '2' },
              { text: '3', value: '3' },
              { text: '4', value: '4' },
              { text: '5', value: '5' },
              { text: '6', value: '6' },
              { text: '7', value: '7' },
              { text: '99', value: '99' },
              { text: 'NA', value: 'NA' },
            ]"
          ></mds-combo-box>
          <mds-date-picker
            style="min-width:150px"
            label="Begin Date"
            v-model="StartDate"
            :min-max-dates="{
              min: new Date(2015, 0, 1),
              max: new Date(2025, 8, 15),
            }"
            :labels="{ month: 'short' }"
            :date-format="{ month: 'short' }"
            readonly
          ></mds-date-picker>
          <mds-date-picker
            style="min-width:150px"
            label="End Date"
            v-model="EndDate"
            :min-max-dates="{
              min: new Date(2015, 0, 1),
              max: new Date(2025, 8, 15),
            }"
            :labels="{ month: 'short' }"
            :date-format="{ month: 'short' }"
            readonly
          ></mds-date-picker>
          <mds-combo-box
            label="Replay Available"
            multiple
            v-model="IsReplayAvailable"
            :data-set="[
              { text: 'Yes', value: 'true' },
              { text: 'No', value: 'false' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Presentation Available"
            multiple
            v-model="IsPresentationAvailable"
            :data-set="[
              { text: 'Yes', value: 'true' },
              { text: 'No', value: 'false' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Collection Status"
            v-model="CollectionStatus"
            multiple
            :data-set="[
              { text: 'Pending', value: 'Pending' },
              { text: 'In Progress', value: 'Inprogress' },
              { text: 'Completed', value: 'Completed' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Job Status"
            v-model="JobIdStatus"
            style="min-width:260px"
            multiple
            :data-set="[
              { text: 'JOB_CREATED', value: '1' },
              { text: 'JOB_CREATION_FAILED', value: '2' },
              { text: 'BATCH_JOB_SUBMITTED', value: '3' },
              { text: 'BATCH_JOB_SUBMISSION_FAILED', value: '4' },
              { text: 'AUDIO_CONVERSION_SKIPPED', value: '5' },
              { text: 'AUDIO_CONVERSION_COMPLETED', value: '6' },
              { text: 'AUDIO_CONVERSION_FAILED', value: '7' },
              { text: 'AUDIO_RECORDER_COMPLETED', value: '8' },
              { text: 'AUDIO_RECORDER_FAILED', value: '9' },
              { text: 'WHISPER_GET_RESPONSE_RECEIVED', value: '10' },
              { text: 'WHISPER_GET_RESPONSE_FAILED', value: '11' },
              { text: 'PYANNOTE_DIARIZATION_COMPLETED', value: '12' },
              { text: 'PYANNOTE_DIARIZATION_FAILED', value: '13' },
              { text: 'TRANSCRIPTION_PROCESSOR_SUCCESS', value: '14' },
              { text: 'TRANSCRIPTION_PROCESSOR_FAILED', value: '15' },
            ]"
          ></mds-combo-box>
        </mds-fieldset>
        <mds-button
          size="medium"
          variation="primary"
          v-on:click.prevent="getEvents(true)"
        >
          Search
        </mds-button>

        <mds-button
          style="margin-left: 10px"
          size="medium"
          variation="primary"
          v-on:click.prevent="refreshEvent()"
        >
          Refresh
        </mds-button>
      </mds-form>
      <div>
        <mds-loader
          size="large"
          aria-label="Large Loader"
          v-if="showLoader"
        ></mds-loader>
        <mds-pagination
          v-if="showPagination"
          show-items-info
          show-items-select
          :total-items="totalRecord"
          @mds-pagination-page-changed="handlePageChange"
          :pageSizes="paginationPageSize"
          :page="paginationOptions.page"
        ></mds-pagination>
        <mds-table zebra-stripes>
          <mds-thead>
            <mds-th style="width: 5%"> Event Id </mds-th>
            <mds-th style="width: 10%"> Event Name </mds-th>
            <mds-th style="width: 9%"> Company Id </mds-th>
            <mds-th style="width: 7%"> Event Type </mds-th>
            <mds-th style="width: 9%"> Beginning Date 
              <button @click="getSortedData($event)" value="BeginningDateDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="BeginningDateAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 5%"> Time </mds-th>
            <mds-th style="width: 7%"> IST DateTime </mds-th>
            <mds-th style="width: 5%"> Priority </mds-th>
            <mds-th style="width: 7%"> Replay Available </mds-th>
            <mds-th style="width: 5%"> Event Details URL </mds-th>
            <mds-th style="width: 5%"> Webcast URL </mds-th>
            <mds-th style="width: 10%"> Collection Status </mds-th>
            <mds-th style="width: 8%"> JobId </mds-th>
            <mds-th style="width: 9%"> Job Status </mds-th>
            <mds-th style="width: 28%"> Action </mds-th>
            
          </mds-thead>
          <mds-tbody>
            <mds-tr
              v-for="(event, eventItemIndex) in eventList"
              :key="event.userid"
            >
              <mds-td> {{ event.eventId }} </mds-td>
              <mds-td> {{ event.eventName }} </mds-td>
              <mds-td> {{ event.companyId }} </mds-td>
              <mds-td> {{ event.eventType }} </mds-td>
              <mds-td> {{ formatDate(event.beginingDate) }} </mds-td>
              <mds-td> {{ event.time }} </mds-td>
              <mds-td> {{ formatISTDate(event.istDate) }} </mds-td>
              <mds-td> {{ event.priority }} </mds-td>
              <mds-td>
                {{
                  event.isReplayAvailable == true
                    ? "Yes"
                    : event.isReplayAvailable == false
                    ? "No"
                    : event.isReplayAvailable
                }}
              </mds-td>
              <mds-td
                ><a
                  style="cursor: pointer"
                  v-bind:title="event.eventDetailUrl"
                  @click="openUrl(event.eventDetailUrl)"
                  v-if="event.eventDetailUrl != ''"
                  >View Url</a
                ></mds-td
              >
              <mds-td
                ><a
                  style="cursor: pointer"
                  v-bind:title="event.webcastUrl"
                  @click="openUrl(event.webcastUrl)"
                  v-if="event.webcastUrl != ''"
                  >View Url</a
                ></mds-td
              >
              <mds-td>
                <mds-select
                  v-bind:value="event.collectionStatus"
                  :id="collectionstatusId + eventItemIndex"
                  placeholder="Select an Option"
                  :options="[
                    { text: 'In progress', value: 'Inprogress' },
                    { text: 'Pending', value: 'Pending' },
                    { text: 'Completed', value: 'Completed' },
                  ]"
                ></mds-select>
              </mds-td>
              <mds-td
                style="word-wrap: break-word"
                :id="JobRowID + eventItemIndex"
              >
                {{ event.jobId }}
              </mds-td>
              <mds-td style="word-wrap: break-word">
                {{ event.jobStatus }}
              </mds-td>
              <mds-td>
                <mds-table>
                  <mds-tr style="width: 100%">
                    <mds-td style="width: 15%">
                      <mds-button
                        variation="primary"
                        v-on:click="saveStatus(eventItemIndex, event.eventId)"
                        size="small"
                        >Save</mds-button
                      >
                    </mds-td>
                    <mds-td style="width: 20%">
                      <mds-button
                        @click="openModel(event.eventId, event.webcastUrl,event.eventName)"
                        size="small"
                        >Upload</mds-button
                      ></mds-td
                    >
                    <mds-td mds-td style="width: 40%">
                      <input
                        type="File"
                        :id="TranscribeFileInput + eventItemIndex"
                        hidden
                        ref="fileInput"
                        style="background-color: #e5e5e5; width: 70%"
                        @change="handleFileChange" />
                      <mds-input
                        :id="TranscribeFile + eventItemIndex"
                        style="background-color: #e5e5e5; color: black"
                        placeholder="Choose Manual File"
                        readonly
                        v-on:click.prevent="chooseFiles(eventItemIndex)"
                        size="medium"
                      ></mds-input
                    ></mds-td>
                    <mds-td style="width: 25%">
                      <mds-button
                        :id="TranscribeButton + eventItemIndex"
                        variation="primary"
                        v-on:click="
                          UploadTranscribe(
                            event.priority,
                            eventItemIndex,
                            event.eventId,
                            event.eventType,
                            event.companyId,
                            event.companyName,
                            event.beginingDate
                          )
                        "
                        disabled
                        size="small"
                        >Transcribe</mds-button
                      >
                    </mds-td>
                  </mds-tr>
                </mds-table>
              </mds-td>
            </mds-tr>
          </mds-tbody>
        </mds-table>
      </div>
    </template>
  </mds-card>
</template>

<script>
import axiosInstance from "@/AxiosTokenInstance";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table-vue3";
import MdsForm from "@mds/form-vue3";
import MdsCard from "@mds/card-vue3";
import MdsComboBox from "@mds/combo-box-vue3";
import MdsInput from "@mds/input-vue3";
import MdsSelect from "@mds/select-vue3";
import MdsFieldset from "@mds/fieldset-vue3";
import { MdsButton } from "@mds/button-vue3";
import MdsDatePicker from "@mds/date-picker-vue3";
import { mapState, mapActions, mapMutations } from "vuex";
import MdsLoader from "@mds/loader-vue3";
import MdsPagination from "@mds/pagination-vue3";
import { ref, watch } from "vue";
import moment, * as moments from "moment";
import MdsModal from "@mds/modal-vue3";
import FileUpload from "../ConferenceCallTracker/FileUpload.vue";
import ModelLoader from "../ModelLoader.vue";
import MdsAlert from "@mds/alert-vue3";
import config from "../../config";
export default {
  name: "ConferenceCallDetails",
  components: {
    MdsCard,
    MdsForm,
    MdsComboBox,
    MdsSelect,
    MdsInput,
    MdsFieldset,
    MdsButton,
    MdsDatePicker,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsLoader,
    MdsPagination,
    FileUpload,
    MdsModal,
    ModelLoader,
    MdsAlert,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      paginationPageSize: [10, 20, 30, 40, 50, 100],
      eventList: [],
      showLoader: false,
      toggle: false,
      showModelLoader: false,
      eventIdProp: "",
      CompanyId: "",
      EventId: "",
      StartDate: "",
      EndDate: "",
      Priority: [],
      IsReplayAvailable: [],
      IsPresentationAvailable: [],
      CollectionStatus: [],
      paginationOptions: {
        page: 1,
      },
      DefaultPageIndex: 1,
      DefaultPageSize: 10,
      totalRecord: "",
      collectionstatusId: "",
      EventStatus: {},
      showAlert: false,
      alertTitle: "",
      alertMessage: "",
      alertVariation: "",
      uploadedDetails: [],
      webcastUrl: "",
      alertTimer: "",
      showPagination: false,
      TranscribeFile: "TranscribeFile",
      TranscribeFileInput: "TranscribeFileInput",
      TranscribeButton: "TranscribeButton",
      JobRowID: "JobRowID",
      selectedFile: null,
      chooseFile: "",
      currentFileIndex: 0,
      lastFileSelected: null,
      eventNameProp:"",
      selectecEventTypes: [],
      EventTypes: [],
      JobIdStatus: [],
      sortInfo: "",
      sort:""
    };
  },
  mounted() {
   // this.getEventStatus(); this is Event Type API call on page load
    this.getEvents(false);
  },
  methods: {
    //Event Type API method
    getEventStatus() {
      axiosInstance
        .get(config.api_url + "ConferenceCallTracker/GetEventTypes", {})
        .then((response) => {
          if (response.data.success) {
            console.log(response.data.data);
            console.log(response.data.data);
            response.data.data.map((item) => {
              this.EventTypes = {
                text: item.eventType,
                value: item.eventTypeId,
              };
            });
          } else {
            this.setAlert(true, "Error Alert", response.data.message, "error");
          }
        })
        .catch((error) => {
          this.setAlert(true, "Error Alert", error.response, "error");
        });
    },

    handleUpdateDetails(updatedDetails) {
      this.uploadedDetails = updatedDetails;
    },
    handleshowModelLoader(showModelLoader) {
      this.showModelLoader = showModelLoader;
    },
    refreshEvent() {
      window.location.reload(); // Reloads the current page
    },
    chooseFiles(index) {
      this.clearSelectedFile();

      if (this.lastFileSelected != null) {
        this.clearSelectedFiles();
        this.enabledisableUpload(this.lastFileSelected, true, "");
      }
      document.getElementById("TranscribeFileInput" + index).accept =
        config.audioFileType;

      this.currentFileIndex = index;
      document.getElementById("TranscribeFileInput" + index).click();
    },
    clearSelectedFiles() {
      this.selectedFile = null;
      this.chooseFile = "";
    },
    enabledisableUpload(buttonIndex, value, controlValue) {
      document.getElementById("TranscribeButton" + buttonIndex).disabled =
        value;
      if (controlValue != "NA")
        document.getElementById("TranscribeFile" + buttonIndex).value =
          controlValue;
    },
    async handleFileChange(event) {
      // Handle file selection
      this.selectedFile = event.target.files[0];
      this.chooseFile = this.selectedFile.name;
      this.enabledisableUpload(this.currentFileIndex, false, this.chooseFile);
      this.lastFileSelected = this.currentFileIndex;
    },
    clearSelectedFile() {
      if (this.lastFileSelected != null) {
        const fileInput = this.$refs.fileInput[this.lastFileSelected];
        if (fileInput) {
          fileInput.value = null;
        }
      }
    },
    getEvents(resetpage) {
      this.showModelLoader = true;
        axiosInstance
        .get(config.api_url + "ConferenceCallTracker/EventDetails", {
          params: {
            EventId: this.EventId,
            EventType:
              this.selectecEventTypes.length == 0
                ? ""
                : this.selectecEventTypes.toString(),
            CompanyId: this.CompanyId,
            StartDate: this.StartDate,
            EndDate: this.EndDate,
            Priority: this.Priority.length == 0 ? "" : this.Priority.toString(),
            IsReplayAvailable:
              this.IsReplayAvailable.length == 0
                ? ""
                : this.IsReplayAvailable.toString(),
            IsPresentationAvailable:
              this.IsPresentationAvailable.length == 0
                ? ""
                : this.IsPresentationAvailable.toString(),
            CollectionStatus:
              this.CollectionStatus.length == 0
                ? ""
                : this.CollectionStatus.toString(),
            JobStatus:
              this.JobIdStatus.length == 0 ? "" : this.JobIdStatus.toString(),
            pageIndex: this.DefaultPageIndex,
            pageSize: this.DefaultPageSize,
            sort: this.sortInfo
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.eventList = response.data.data.eventList;
            this.totalRecord = response.data.data.totalRecords;
            if (this.totalRecord != 0) {
              if (resetpage) {
                this.paginationOptions.page = 1;
              }
              this.showPagination = true;
            } else {
              this.showPagination = false;
            }
          } else {
            this.setAlert(true, "Error Alert", response.data.message, "error");
          }
          this.showModelLoader = false;
        })
        .catch((error) => {
          this.setAlert(true, "Error Alert", error.response, "error");
          this.showModelLoader = false;
        });
    },
    handlePageChange(paginationOptions) {
      this.paginationOptions = paginationOptions;
      this.DefaultPageIndex = paginationOptions.page;
      this.DefaultPageSize = paginationOptions.pageSize;
      this.getEvents(false);
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    openModel(eventId, webcastUrl,eventName) {
      this.toggle = !this.toggle;
      this.eventIdProp = eventId;
      this.eventNameProp = eventName;
      this.webcastUrl = webcastUrl;
      if (this.webcastUrl === null || this.webcastUrl === "") {
        this.webcastUrl = null;
      }
      this.showModelLoader = true;
      axiosInstance
        .get(
          `${config.api_url}ConferenceCallTracker/get-upload-data?eventId=${this.eventIdProp}&webcastUrl=${this.webcastUrl}`
        )
        .then((response) => {
          if (response.data.success)
            this.uploadedDetails = response.data.data.uploadedData;
          else
            this.setAlert(true, "Error Alert", response.data.message, "error");
        })
        .catch((error) => {
          this.setAlert(true, "Error Alert", error, "error");
        })
        .finally(() => {
          this.showModelLoader = false;
        });
    },
    formatDate(date) {
      var formatedDate = moment(date).format("YYYY-MM-DD");
      return formatedDate;
    },
    formatISTDate(datevalue) {
  if (datevalue) {
    var formatedISTDate = moment(datevalue).format("YYYY-MM-DD HH:mm:ss");
    return formatedISTDate;
  } else {
    return ''; 
  }
},

    setAlert(flag, tile, message, varation) {
      this.showAlert = flag;
      this.alertTitle = tile;
      this.alertMessage = message;
      this.alertVariation = varation;
      window.scrollTo(0, 0);
      if (flag) this.autoCloseAlert();
    },
    closeAlert() {
      this.setAlert(false, "", "", "");
      if (this.alertTimer) clearTimeout(this.alertTimer);
    },
    autoCloseAlert() {
      this.alertTimer = setTimeout(() => {
        this.closeAlert();
      }, config.alertTime * 1000);
    },
    async UploadTranscribe(
      priority,
      index,
      EventId,
      EventType,
      CompanyId,
      CompanyName,
      BeginingDate
    ) {
      // Validation 1: Select file
      if (this.selectedFile == "" || this.selectedFile == null) {
        this.setAlert(true, "Warning Alert", "Please Choose File", "warning");
        return;
      }
      // Validation 2: Only Audio and Video File
      if (this.selectedFile) {
        const arrfileExt = config.audioFileType.replaceAll(".", "").split(",");
        var ext = this.selectedFile.name.split(".").pop();
        if (!arrfileExt.includes(ext)) {
          this.setAlert(
            true,
            "Warning Alert",
            ext + " this file not supported, only allowed " + arrfileExt,
            "warning"
          );
          return;
        }
      }

      try {
        this.showModelLoader = true;
        const apiUrl = `${config.api_url}ConferenceCallTracker/transcribe`;
        const createdByValue = parseInt(this.userDetails.data.userId, 10);
        const formData = new FormData();
        formData.append("Priority", priority);
        formData.append("EventId", EventId);
        formData.append("EventType", EventType);
        formData.append("CompanyId", CompanyId);
        formData.append("CompanyName", CompanyName);
        formData.append("EventDate", BeginingDate);
        formData.append("FilePurpose", "audio_processing");
        formData.append("FileFormat", ext);
        formData.append("createdBy", createdByValue);
        formData.append("File", this.selectedFile);

        const response = await axiosInstance.post(apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.success) {
          this.setAlert(true, "Success Alert", "Success", "success");
          document.getElementById(this.JobRowID + index).innerText =
            response.data.message;
          this.showModelLoader = false;
        } else {
          this.setAlert(true, "Error Alert", response.data.message, "error");
          this.showModelLoader = false;
        }
      } catch (error) {
        this.setAlert(true, "Error Alert", error, "error");
        this.showModelLoader = false;
      } finally {
        if (this.connection) {
          this.clearSelectedFiles();
          await this.connection.stop();
        }
        this.clearSelectedFiles();
        this.enabledisableUpload(index, true, "NA");
      }
    },
    saveStatus(index, EventId) {
      this.closeAlert();
      var selectedStatus = document.getElementById(
        this.collectionstatusId + index
      ).value;
      if (selectedStatus == "" || selectedStatus == null)
        this.setAlert(
          true,
          "Warning Alert",
          "Please select Collection Status for Event Id :" + EventId,
          "warning"
        );
      else {
        this.EventStatus.EventId = EventId;
        this.EventStatus.CollectionStatus = selectedStatus;
        this.showModelLoader = true;
        axiosInstance
          .post(
            config.api_url + "ConferenceCallTracker/SaveEventStatus",
            this.EventStatus
          )
          .then((response) => {
            if (response.data.success) {
              if (response.data.data == "Validation")
                this.setAlert(
                  true,
                  "Warning Alert",
                  response.data.message,
                  "warning"
                );
              else
                this.setAlert(
                  true,
                  "Success Alert",
                  response.data.message,
                  "success"
                );
            } else
              this.setAlert(
                true,
                "Error Alert",
                response.data.message,
                "error"
              );
            this.showModelLoader = false;
          })
          .catch((error) => {
            this.setAlert(true, "Error Alert", error.response, "error");
            this.showLoader = false;
          });
      }
    },
    getSortedData(event){
        this.sortInfo = event.currentTarget._value=="BeginningDateDesc"?"DESC" : event.currentTarget._value=="BeginningDateAsc"? "ASC": "";
        this.getEvents(false);
    }
  },
  computed: {
    ...mapState("auth", {
      userDetails: (state) => state.userDetails,
    }),
    
    paginatedData() {
      const start = this.paginationOptions
        ? this.paginationOptions.firstItem - 1
        : 0;
      const end =
        this.paginationOptions && this.paginationOptions.pageSize !== -1
          ? start + this.paginationOptions.pageSize
          : this.eventList.length;
      return this.eventList.slice(start, end);
    },
  },
};
</script>
<style lang="scss" module>
*,
#fieldset1::before,
#fieldset1::after {
  margin-right: 15px;
}
</style>
